import { render, staticRenderFns } from "./RateRegisterPage.vue?vue&type=template&id=2e55e1a8&scoped=true&"
import script from "./RateRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./RateRegisterPage.vue?vue&type=script&lang=ts&"
import style0 from "./RateRegisterPage.vue?vue&type=style&index=0&id=2e55e1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55e1a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VTextField,VTooltip})
